<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="480px"
    @close="$router.replace('/data/services/categories')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="serviceCategory"
      :rules="rules"
      ref="serviceCategoryForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input v-model="serviceCategory.name" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/services/categories')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'serviceCategoryId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        serviceCategory: {},
        rules: {
          name: [
            { required: true, message: 'Név megadása kötelező', trigger: 'change' }
          ]
        }
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Szolgáltatáskategória';
        } else if (this.type === 'update') {
          return 'Szolgáltatáskategória módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['serviceCategoryForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('serviceCategory/create', this.serviceCategory);
              } else if (this.type === 'update') {
                await this.$store.dispatch('serviceCategory/update', this.serviceCategory);
              }
              this.$store.dispatch('serviceCategory/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/data/services/categories');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if (this.serviceCategoryId) {
        this.serviceCategory = await this.$store.dispatch('serviceCategory/fetch', this.serviceCategoryId);
      }
      this.loading = false;
    }
  };
</script>
